module.exports = {"520402001":"南街街道","520402002":"东街街道","520402003":"西街街道","520402004":"北街街道","520402005":"东关街道","520402006":"华西街道","520402007":"西航街道","520402100":"宋旗镇","520402101":"幺铺镇","520402102":"宁谷镇","520402103":"龙宫镇","520402104":"双堡镇","520402105":"大西桥镇","520402106":"七眼桥镇","520402107":"蔡官镇","520402108":"轿子山镇","520402109":"旧州镇","520402200":"新场布依族苗族乡","520402201":"岩腊苗族布依族乡","520402202":"鸡场布依族苗族乡","520402203":"杨武布依族苗族乡","520402204":"东屯乡","520402205":"黄腊布依族苗族乡","520402206":"刘官乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520402.json
// module id = 2290
// module chunks = 0